export const environment = {
  contentPrefix: 'https://beelineru-mediacom-prod.intech-global.com/',
  googleTag: 'GTM-WWSF97W4',
  yaMetrics: '96550867',
  appUrl: 'https://beelineru-mediacom-test.intech-global.com',
  showGiftButton: true
};
